import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import type { CurrentUserResponse } from '@/tygo/dto'

export const Route = createFileRoute('/admin')({
  beforeLoad: ({ context }) => {
    const user = context.queryClient.getQueryData<CurrentUserResponse>(['user'])
    if (!user) {
      throw redirect({ to: '/login' })
    }
    if (!user.user.is_admin) {
      throw redirect({ to: '/' })
    }
  },
  component: AdminLayout,
})

function AdminLayout() {
  return (
    <div className="flex flex-col items-center py-10 lg:py-20">
      <div className="w-full max-w-4xl px-4">
        <Outlet />
      </div>
    </div>
  )
}
